import ResilientTriggeredHookBuilder from "../../../Hooks/ResilientTriggeredHookBuilder";
import useGetCalendar from "../Hooks/useGetCalendar";
import useUpdatePreparedCustomer from "../Hooks/useUpdatePreparedCustomer";

/**
 * Combines the {@link useGetCalendar} and {@link useUpdatePreparedCustomer} hooks into a single resilient process.
 * @remarks Calls {@link useGetCalendar} first. If it fails with a 400 response, call {@link useUpdatePreparedCustomer},
 * and then retry the call to {@link useGetCalendar} and return it.
 */
const useResilientGetCalendar = ResilientTriggeredHookBuilder(
  useGetCalendar,
  useUpdatePreparedCustomer,
  primaryHookError => primaryHookError.response?.status === 400
);

export default useResilientGetCalendar;
